import moment from 'moment';
import { Math } from 'core-js';

const WeekHelper = new (function () {
    /**
     * Pads with leading zeroes. e.g. ToStringLeadingZeroes(9,2) '09'.
     */
    this.ToStringLeadingZeroes = (number, numberOfCharacters) => {
        let s = number.toString();
        while (s.length < numberOfCharacters) {
            s = '0' + s;
        }
        return s;
    };

    /**
     * 
     * e.g. 2019-12-30 = "202001"
     *      2021-01-01 = "202053"
     */
    this.GetWeek = (date) => {
        let week = moment(date).isoWeek();
        let year = moment(date).year();
        let month = moment(date).month();
        let weekString = week.toString();

        if (month === 0 && week >= 52) {
            year--;
        }
        else if (week === 1 && month === 11) {
            year++;
        }

        if (weekString.length === 1) {
            weekString = "0" + weekString;
        }
        
        return year.toString() + weekString;
    }

    /**
     * e.g. GetWeeksBetween('202053', '202101') = ['202053', '202101'].
     */
    this.GetWeeksBetween = (startYearWeek, endYearWeek) => {
        let weeks = [];

        const startYear = parseInt(startYearWeek.substring(0, 4));
        const startWeek = parseInt(startYearWeek.substring(4, 6));
        const endYear = parseInt(endYearWeek.substring(0, 4));
        const endWeek = parseInt(endYearWeek.substring(4, 6));

        if (endYear < startYear) {
            return weeks;
        }

        let currentYear = startYear;
        let currentWeek = startWeek;
        let lastWeekCurrentYear = this.GetLastWeekOfYear(currentYear);

        while (currentYear < endYear || currentWeek <= endWeek) {
            weeks.push(this.ToStringLeadingZeroes(currentYear, 4) + this.ToStringLeadingZeroes(currentWeek, 2));
            currentWeek++;
            if (currentWeek > lastWeekCurrentYear && currentYear < endYear) {
                currentWeek = 1;
                currentYear++;
                lastWeekCurrentYear = this.GetLastWeekOfYear(currentYear);
            }
        }

        return weeks;
    };

    /**
     * e.g. GetNumberOfWeeksBetween('202053', '202101') = 2.
     */
    this.GetNumberOfWeeksBetween = (startYearWeek, endYearWeek) => {
        return this.GetWeeksBetween(startYearWeek, endYearWeek).length;
    };

    this.YearSplitWeeks = (weeks) => {
        if (weeks.length <= 0) {
            return weeks;
        } else {
            const tmpWeeks = [];

            let currYear = weeks[0].substring(0, 4);
            let index = -1;
            weeks.map((element) => {
                let loopYear = element.substring(0, 4);
                if (tmpWeeks.length !== 0 && currYear === loopYear) {
                    tmpWeeks[index].push(element);
                } else {
                    tmpWeeks.push([element]);
                    currYear = loopYear;
                    index++;
                }
                return null;
            });

            return tmpWeeks;
        }
    };

    /**
     * Returns Date object.
     */
    this.GetLastWeekOfYear = (year) => {
        let date = moment(`${year}-12-28`, 'YYYY-MM-DD');
        let week = date.isoWeek();
        return week;
    };

    /**
     * In format 'yyyyww', out Date object.
     */
    this.GetMondayDateOfWeek = (yearWeek) => {
        let year = parseInt(yearWeek.substring(0, 4));
        let week = parseInt(yearWeek.substring(4, 6));

        let monday = moment().year(year).isoWeek(week).isoWeekday(1);

        return monday.toDate();
    };

    /**
     * e.g. AddWeeks('202045', 10) = 202102'. Takes positive, negative and zero n.
     */
    this.AddWeeks = (yearWeek, n) => {
        if (n === 0) {
            return yearWeek;
        }

        let currentYear = parseInt(yearWeek.substring(0, 4));
        let currentWeek = parseInt(yearWeek.substring(4, 6));

        if (n > 0) {
            let lastWeekCurrentYear = this.GetLastWeekOfYear(currentYear);

            for (let i = 0; i < n; i++) {
                currentWeek++;
                if (currentWeek > lastWeekCurrentYear) {
                    currentWeek = 1;
                    currentYear++;
                    lastWeekCurrentYear = this.GetLastWeekOfYear(currentYear);
                }
            }
        } else {
            n = Math.abs(n);
            for (let i = 0; i < n; i++) {
                currentWeek--;
                if (currentWeek < 1) {
                    currentYear--;
                    currentWeek = this.GetLastWeekOfYear(currentYear);
                }
            }
        }

        return this.ToStringLeadingZeroes(currentYear, 4) + this.ToStringLeadingZeroes(currentWeek, 2);
    };
})();

export default WeekHelper;
